/**
 * O módulo WhatsApp está ligado nesta instalação?
 *
 * Fase 9 da correção da auditoria. O achado M-TRA-12 dizia "WhatsApp é
 * fachada": o módulo aparecia na barra lateral, tinha inbox, badge e um
 * polling a cada 10 segundos — para uma capacidade que o sistema não
 * tem. As quatro variáveis `WHATSAPP_*` nunca existiram no deployment, o
 * serviço Node nunca subiu em lugar nenhum, e o backend responde
 * `401 "webhook secret ausente"` até hoje.
 *
 * Enquanto o serviço não estiver no ar, o correto é o sistema não
 * anunciar o que não faz — e não gastar uma request a cada 10 segundos,
 * por usuário, buscando conversas que não existem.
 *
 * Ligar: `REACT_APP_WHATSAPP_ENABLED=true` no build.
 *
 * Kill-switch pelo mesmo padrão de `REACT_APP_ACESSOS_V2_ENABLED`, já
 * usado no projeto para gatear módulo em transição.
 */

export function whatsappHabilitado() {
  return String(process.env.REACT_APP_WHATSAPP_ENABLED || "")
    .trim()
    .toLowerCase() === "true";
}

export default whatsappHabilitado;
